<div
    (mouseenter)="collapseOpenSidenav()"
    (mouseleave)="collapseCloseSidenav()"
    [class.collapsed]="collapsed"
    [class.open]="collapsed && (collapsedOpen$ | async)"
    class="flex flex-col vex-sidenav"
>
    <div class="vex-sidenav-toolbar__container">
        <div class="flex items-center flex-none sidenav-toolbar">
            <img src="assets/img/logo/logo-dark.png" alt="Logo" class="flex-none h-8 select-none" />
            <h2 class="flex-auto vex-sidenav-toolbar__headline">
                {{ title$ | async }}
            </h2>
            <button
                (click)="toggleCollapse()"
                *ngIf="showCollapsePin$ | async"
                class="flex-none hidden -mr-4 leading-none vex-sidenav-toolbar__collapse-toggle lg:block"
                mat-icon-button
                type="button"
            >
                <mat-icon *ngIf="!collapsed" class="icon-xs">radio_button_checked</mat-icon>
                <mat-icon *ngIf="collapsed" class="icon-xs">radio_button_unchecked</mat-icon>
            </button>
        </div>

        <div class="vex-sidenav-toolbar__divider"></div>
    </div>

    <vex-scrollbar class="flex flex-col flex-1">
        <div class="flex-1 pt-6">
            @for (item of items$ | async; track $index) {
                <vex-sidenav-item [item]="item" [level]="0"></vex-sidenav-item>
            }
        </div>
    </vex-scrollbar>

    <div class="text-xs text-center border-t border-gray-200/10">
        <vex-build-info [isSidebar]="true" class="opacity-50"></vex-build-info>
    </div>
</div>
